export default {
  '': 'NetPlay',
  'articles': 'Good Luck, Have Fun!',
  'sign-out': 'Sign Out',
  'privacy-policy': 'Privacy Policy',
  'terms-of-service': 'Terms of Service',
  'verification': 'Verification Step',
}



// WEBPACK FOOTER //
// ./src/app/const/routeTitles.js